module.exports = __webpack_public_path__ + "img/logo-gtbs.29e4391a.png";